import { BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode } from "@/api/graphql/types/graphql";

export enum AddTidLinkedAccountDrawerContext {
  delegate = "delegate",
  payer = "payer",
}

interface AddDrawerUi {
  titleKey: string;
  dataTestIdPrefix: string;
  tidTypeCode: BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode;
}

const ADD_TID_LINKED_ACCOUNT_DRAWER_UI: Record<
  AddTidLinkedAccountDrawerContext,
  AddDrawerUi
> = {
  delegate: {
    titleKey: "companies.tid.drawer.add.delegate.title",
    dataTestIdPrefix: "tid-delegate",
    tidTypeCode:
      BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode.Delegate,
  },
  payer: {
    titleKey: "companies.tid.drawer.add.payer.title",
    dataTestIdPrefix: "tid-payer",
    tidTypeCode:
      BillingMsGetAccountsLinkableToTidRequestFiltersTidTypeCode.Payer,
  },
};

export const getAddTidLinkedAccountDrawerUi = (
  context: AddTidLinkedAccountDrawerContext,
): AddDrawerUi => ADD_TID_LINKED_ACCOUNT_DRAWER_UI[context];
